<template>
    <div class="row align-items-center">
        <div class="col-md-3">
            <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                <br><br>
            </h3>
        </div>
        <div class="col-md-9 text-right">
            <base-dropdown class="nav-link pr-0 float-right" position="right">
                <div class="media align-items-center" slot="title">
                    <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                </div>
                <template>
                    <div class=" dropdown-header noti-title">
                        <h6 class="text-overflow m-0">ACTIONS</h6>
                    </div>
                    <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                        <i class="fa fa-list-ul"></i>
                        <span>Customize List</span>
                    </div>
                    <div class=" dropdown-header noti-title">
                        <h6 class="text-overflow m-0">SHOW</h6>
                    </div>
                    <div class="dropdown-item">
                        <i class="fa fa-upload"></i>
                        <span>Percent Discount</span>
                    </div>
                    <div class="dropdown-item">
                        <i class="fa fa-download"></i>
                        <span>Amount Discount</span>
                    </div>
                    <div class="dropdown-item">
                        <i class="fa fa-print"></i>
                        <span>New Price</span>
                    </div>
                </template>
            </base-dropdown>
            <div v-if="accessRights.includes('A')">
                <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer(0, promoType)">+ Add Promo</base-button>
            </div>
        </div>

        <div class="col-md-12">
            <div v-if="successMessage != null">
                <base-alert type="primary" dismissible>
                    <span class="alert-inner--text"> {{successMessage}}</span>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </base-alert>
            </div>
        </div>

        <a-drawer title="" :width="800" placement="right" @close="onClose" :visible="historyVisible">
          <div>
            <h6 class="heading-small text-muted mb-4 text-truncate">Promotion Action History</h6>
            <a-table :columns="historyColumns" :dataSource="historyData" size="small"/>
          </div>
        </a-drawer>

        <div class="col">
            <div class="table-responsive pt-2">
              <div id="example-table"></div>

              <a-table
                size="small"
                :columns="tableColumns"
                :dataSource="promotions"
                :rowKey="(record) => record.id"
                :scroll="{ x: 1300 }"
                :pagination="pagination"
                @change="allData">

                <template slot="action" slot-scope="action">
                  <center>
                    <div class="table-button-container">
                       <button
                        class="btn btn-sm btn-primary"
                        @click.prevent="showActionHistory(action)"
                      >
                        History
                      </button>
                      <button
                        v-if="accessRights.includes('V')"
                        class="btn btn-sm btn-success"
                        @click.prevent="actionPromotion(action, 'view')"
                      >
                        View
                      </button>
                      <button
                        v-if="accessRights.includes('W')"
                        class="btn btn-sm btn-warning"
                        @click.prevent="actionPromotion(action, 'edit')"
                        :disabled="action.status == 'U'"
                      >
                        Edit
                      </button>
                      <button
                        v-if="accessRights.includes('D')"
                        class="btn btn-sm btn-danger"
                        @click.prevent="actionPromotion(action, 'delete')"
                        :disabled="action.status == 'U'"
                      >
                        Delete
                      </button>
                    </div>
                  </center>
                </template>
              </a-table>
            </div>
        </div>

        <a-drawer :width="windowWidth" placement="right" @close="onClose" :visible="visible">
            <div>
                <promotion-form @closeDrawer="closeDrawer" :promoType="promoType" :key="componentKey" :viewMode="viewMode" v-on:refreshPage="refreshPage"></promotion-form>
            </div>
        </a-drawer>

        <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
            <div v-if="profileAction == 'customize_list'">
                <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
                <ul v-if="availableFields.length > 0" class="list-group list-group-flush" style="width: 100%">
                <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                    <div class="row">
                        <div class="col-md-6">
                            AVAILABLE FIELDS
                        </div>
                        <div class="col-md-6">
                            <a-checkbox @change="onCheckAllField" :checked="checkedFields.length == availableFields.length"
                            class="float-right" />
                        </div>
                    </div>
                </li>

                <li class="list-group-item" style="font-size: 14px" v-for="field in availableFields" v-bind:key="field">
                    <div class="row">
                        <div class="col-md-6">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{field}}
                        </div>
                        <div class="col-md-6">
                            <a-checkbox
                              @change="onCheckField(field)"
                              :checked="checkedFields.includes(field)"
                              :disabled="field == 'name'"
                              class="float-right" />
                        </div>
                    </div>
                </li>
                </ul>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import axios from "axios";
    import { mapState, mapActions } from 'vuex'
    import secureStorage from '../../controllers/secureStorage';
    import HTTPRequest from '../../controllers/httpRequest.js'
    import PromotionForm from '../Promotions/PromotionForm'
    import moment from 'moment';

    import Tabulator from 'tabulator-tables';
    var table;
    var component_x;

    export default {
        components: {
            PromotionForm
        },
        data() {
            return {
                spinning: false,
                tabledata: [],
                promotions: [],
                defaultTableColumns: [
                  {
                    title: "Code",
                    width: 150,
                    dataIndex: "code",
                    key: "code"
                  },
                  {
                    title: "Promotion Name",
                    width: 250,
                    dataIndex: "name",
                    key: "name",
                  },
                  {
                    title: "Status",
                    width: 100,
                    dataIndex: "status",
                    key: "status",
                  },
                  {
                    title: "Start Date",
                    width: 100,
                    dataIndex: "start_date",
                    key: "start_date",
                  },
                  {
                    title: "End date",
                    width: 100,
                    dataIndex: "end_date",
                    key: "end_date",
                  },
                  {
                    title: "Duration Status",
                    width: 150,
                    dataIndex: "duration_status",
                    key: "duration_status",
                  },
                  {
                    title: "Updated At",
                    width: 200,
                    dataIndex: "updated_at",
                    key: "updated_at",
                  },
                  {
                    title: "Updated By",
                    width: 100,
                    dataIndex: "updated_by",
                    key: "updated_by",
                  },
                  {
                    title: "Created At",
                    width: 200,
                    dataIndex: "created_at",
                    key: "created_at",
                  },
                  {
                    title: "Created By",
                    width: 100,
                    dataIndex: "created_by",
                    key: "created_by",
                  },
                  {
                    title: "Actions",
                    key: "action",
                    fixed: "right",
                    width: 300,
                    scopedSlots: { customRender: "action" },
                  }
                ],
                tableColumns: [],
                // columns: [
                //   {
                //     title:'PROMO NAME',
                //     width: "15%",
                //     field:'name',
                //     headerSort: false,
                //     formatter:"textarea"
                //   },
                //   {
                //     title: 'STATUS',
                //     width: "10%",
                //     field: 'status',
                //     headerSort: false
                //   },
                //   {
                //     title: 'START DATE',
                //     width: "10%",
                //     field: 'start_date',
                //     headerSort: false,
                //     formatter: this.dateFormatter,
                //   },
                //   {
                //     title: 'END DATE',
                //     width: "10%",
                //     field: 'end_date',
                //     headerSort: false,
                //     formatter: this.dateFormatter,
                //   },
                //   {
                //     title: 'DURATION STATUS',
                //     width: "10%",
                //     field: 'duration_status',
                //     headerSort: false
                //   },
                //   {
                //     title: 'CREATED AT',
                //     width: "10%",
                //     field: 'created_at',
                //     headerSort: false,
                //     formatter: this.dateTimeFormatter,
                //   },
                //   {
                //     title: 'UPDATED AT',
                //     width: "10%",
                //     field: 'updated_at',
                //     headerSort: false,
                //     formatter: this.dateTimeFormatter,
                //   },
                //   {
                //     title: 'CREATED BY',
                //     width: "10%",
                //     field: 'created_by',
                //     headerSort: false,
                //     formatter: "textarea",
                //   },
                //   {
                //     title: 'UPDATED BY',
                //     width: "10%",
                //     field: 'updated_by',
                //     headerSort: false,
                //     formatter: "textarea",
                //   },
                //   {
                //     title: 'ACTIONS',
                //     width: "20%",
                //     frozen: true,
                //     headerSort: false,
                //     formatter: this.addButton,
                //     cellClick: this.selectPromoAction
                //   }
                // ],
                options: {
                  height: "100%",
                  layout:"fitDataStretch",
                  pagination:"remote",
                  ajaxConfig: {
                    method:"GET",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") },
                  },
                  paginationDataSent:{
                    "page":"page",
                    "size":"per_page"
                  },
                  paginationSize:10,
                  columns: []
                },
                windowWidth: 0,
                drawerVisible: false,
                visible: false,
                viewMode: false,
                componentKey: 0,
                successMessage: null,
                type: null,
                profileAction: "",
                availableFields: [],
                checkedFields: ["name", "status", "start_date", "end_date", "duration_status", "updated_at", "updated_by"],
                promoType: this.$attrs.promoType,
                accessRights: [],
                historyData: [],
                historyVisible: false,
                historyColumns: [
                  {
                  title: 'Action',
                  dataIndex: 'action',
                  },
                  {
                  title: 'Action By',
                  dataIndex: 'action_by',
                  },
                  {
                  title: 'Action At',
                  dataIndex: 'action_at',
                  customRender: (value) => <div>{moment(value).format('YYYY-MM-DD HH:mm:ss A')}</div>
                  },
                ],
                initLoad: true,
                pagination: {
                  pageSize: 10,
                },
            }
        },
        beforeMount: async function(){
          const advancedPromotionCustomList = localStorage.advancedPromotionCustomList
          // console.log(advancedPromotionCustomList)
          if(advancedPromotionCustomList != undefined && advancedPromotionCustomList != null && advancedPromotionCustomList != "[]"){
            this.checkedFields = JSON.parse(advancedPromotionCustomList)
            await this.allData()
          }else{
            localStorage.removeItem("advancedPromotionCustomList")
          }
        },
        mounted: async function () {
            component_x = this;

            var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + this.$attrs.moduleId, null)
            if (_.isEmpty(accessRightsRequest.access_rights) == false){
                this.accessRights = accessRightsRequest.access_rights[this.$attrs.moduleId]
            }else {
                this.accessRights = []
            }

            this.allData()

            this.$nextTick(function() { //for fullscreen drawer
                window.addEventListener('resize', this.getWindowWidth);
                this.getWindowWidth()
            })
        },
        beforeDestroy() { //for fullscreen drawer
            window.removeEventListener('resize', this.getWindowWidth);
        },
        computed: {
            ...mapState(['endPoint'])
        },
        methods: {
            ...mapActions(['updateProfileId']),
            moment,
            getWindowWidth(event) { //for fullscreen drawer
                this.windowWidth = window.innerWidth
            },
            onClose() {
                this.drawerVisible = false
                this.visible = false
                this.historyVisible =false
                this.componentKey++
            },
            async showActionHistory(action){
              this.historyVisible = true
              var userHistory = await HTTPRequest.getRequest(this.endPoint + "promotions_action_histories/"+action.id+"?field_name=promotion_id", null);
              this.historyData = userHistory
            },
            closeDrawer(){
                this.onClose()
            },
            async showDrawer(id, type) {
                this.componentKey++
                this.updateProfileId(id)
                this.promoType = type
                this.visible = true
            },
            async showActionDrawer(action) {
              if (action == "customize_list") {
                var response = await HTTPRequest.getRequest(
                  this.endPoint + this.currentProfile + "/get_viewable_fields",
                  null
                );
                
                let unsortedFields = response["fields"];
                let sortedFields = this.checkedFields.slice();

                unsortedFields.forEach(fieldName => {
                  if (!this.checkedFields.includes(fieldName))
                    sortedFields.push(fieldName)
                });

                this.availableFields = sortedFields;

              }
              this.profileAction = action;
              this.drawerVisible = true;
            },
            allData: async function(pagination) {
              var page = { ...this.pagination };
              if (pagination !=undefined){ page = { ...pagination } }
              (page.current == undefined) ? page.current = 1 : ''
              this.changeTableColumns();
              this.options.ajaxURL = this.endPoint + 'promotions?promo_type=' + this.promoType+'&page='+page.current +'&per_page='+page.pageSize
              const request = await HTTPRequest.getRequest(this.endPoint + 'promotions?promo_type=' + this.promoType+'&page='+page.current+'&per_page='+page.pageSize, null)
              page.total = request.total
              page.pageSize = request.per_page
              this.pagination = page
              request.data.map(promotion => {
                promotion.start_date = this.dateFormatter(promotion.start_date)
                promotion.end_date = this.dateFormatter(promotion.end_date)
                promotion.created_at = this.dateTimeFormatter(promotion.created_at)
                promotion.updated_at = this.dateTimeFormatter(promotion.updated_at)
              })

              this.promotions = request.data;
              this.initLoad = false
            },
            changeTableColumns() {
              if (this.checkedFields.length < 2) {
                if (!this.initLoad) {
                  this.$notification['warning']({
                    message: 'Customized columns cannot be empty',
                    description: 'Columns reset to default.',
                    placement: 'bottomRight'
                  })
                }

                this.checkedFields = ["name", "status", "start_date", "end_date", "duration_status", "updated_at", "updated_by"]
                // this.tableColumns = this.defaultTableColumns.slice()
                localStorage.removeItem("advancedPromotionCustomList")
              }
              this.tableColumns = this.defaultTableColumns.filter(column => this.checkedFields.includes(column.dataIndex));
              this.tableColumns = [...this.tableColumns, this.defaultTableColumns[this.defaultTableColumns.length - 1]];
            },
            actionPromotion(promotion, action) {
              let promo_id = promotion.id
              switch (action) {
              case "view":
                  this.viewMode = true
                  this.showDrawer(promo_id, promotion.promo_type)
                  break;
              case "edit":
                  this.viewMode = false
                  this.showDrawer(promo_id, promotion.promo_type)
                  break;
              case "delete":
                  let result = confirm("This will de-activate this promotion. Do you want to continue?");
                  if (result) {
                    this.deleteData(promo_id)
                  }
                  break;
              default:
                  break;
              }
            },
            addButton (cell, formatterParams){
                let id = cell.getRow().getData().id
                var button = ""
                if(this.accessRights.includes('V'))
                    button += '<button id="add_' + id + '" name="View" class="btn btn-success btn-sm">View</button>'
                if(this.accessRights.includes('W'))
                    button += '<button id="edit_' + id + '" name="Edit" class="btn btn-sm btn-warning">Edit</button>'
                if(this.accessRights.includes('D'))
                    button += '<button id="delete_' + id + '" name="Delete" class="btn btn-sm btn-danger">Delete</button>'
                return button
            },
            dateFormatter (value) {
              const formattedDate = moment(value , "YYYY-MM-DD").format("MM-DD-YYYY");
              return formattedDate;
            },
            dateTimeFormatter (value) {
              const formattedDate = moment(value).format("MM-DD-YYYY h:mm A");
              return formattedDate;
            },
            async onCheckAllField() {
              if(this.checkedFields.length == this.availableFields.length){
                  this.checkedFields = ["name"]
              } else {
                  this.checkedFields = this.availableFields.slice()
              }
              localStorage.setItem("advancedPromotionCustomList", JSON.stringify(this.checkedFields))
              await this.allData();
            },
            async onCheckField(fieldName) {
                // if(this.checkedFields.includes(fieldName)){
                //     let indexValue = this.fields.indexOf(fieldName)
                //     if (indexValue > -1) this.fields.splice(indexValue, 1)
                //     let indexValue2 = this.checkedFields.indexOf(fieldName)
                //     if (indexValue2 > -1) this.checkedFields.splice(indexValue2, 1)
                // } else{
                //     if (!this.fields.includes(fieldName)) {
                //         this.fields.pop()
                //         this.fields.push(fieldName)
                //         this.fields.push("__slot:actions")
                //     }
                //     this.checkedFields.push(fieldName)
                // }

              if(this.checkedFields.includes(fieldName)){
                let indexValue2 = this.checkedFields.indexOf(fieldName)
                if (indexValue2 > -1) this.checkedFields.splice(indexValue2, 1)
              } else {
                this.checkedFields.push(fieldName)
              }

              localStorage.setItem("advancedPromotionCustomList", JSON.stringify(this.checkedFields))
              await this.allData();
              // this.changeTableColumns();

              // const tabulator = this.$refs.promotionTable.getInstance()
              // tabulator.redraw(true)
              // console.log(this.promotions);
            },
            refreshPage() {
                this.allData()
                this.successMessage = "Successful Operation"
                this.initLoad = true
                this.onClose()
            },
            selectPromoAction: function(e, cell){
                if(e.target.id != ""){
                    let promo_id = cell.getRow().getData().id
                    switch (e.target.name) {
                    case "View":
                        this.viewMode = true
                        this.showDrawer(promo_id, cell.getRow().getData().promo_type)
                        break;
                    case "Edit":
                        this.viewMode = false
                        this.showDrawer(promo_id, cell.getRow().getData().promo_type)
                        break;
                    case "Delete":
                        this.deleteData(promo_id)
                        break;
                    default:
                        break;
                    }
                }
            },
            deleteData: async function(id){
                axios({
                    method: 'delete',
                    url: this.endPoint + 'promotions/' + id,
                    headers: {
                        Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                        "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
                    },
                })
                .then(function () {
                    component_x.successMessage = "Successfully deleted record"
                    component_x.refreshPage()
                })
            },
        }
    }
</script>

<style lang='scss'>
    @import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
    .tabulator-group-toggle{
        display: none;
    }
</style>
